import { links } from "@p81-common/shell-core-js";

// ── Icon URLs ──

export const trashIconSrc = `${links.imagesBaseUrl}/icons3/icon_trash.svg`;
export const editIconSrc = `${links.imagesBaseUrl}/icons3/icon_edit_new.svg`;
export const caretIconSrc = `${links.imagesBaseUrl}/icons2/icon_arrow.svg`;
export const customRoleIconSrc = `${links.imagesBaseUrl}/icons2/icon_userSettings.svg`;
export const permissionGroupIconSrc = `${links.imagesBaseUrl}/icons/icon_key.svg`;
export const noResultsImgSrc = `${links.imagesBaseUrl}/png/noresults_Generic.png`;

// ── Layout ──

export const LAYOUT_SCROLL_TARGET_ID = "layoutContainer";

// ── Column sizing (CardGrid `flex` / `width` units) ──

export const ROLE_COLUMN_FLEX = 2.1;
export const ROLE_COLUMN_MIN_WIDTH = 260;

export const PERMISSIONS_COLUMN_FLEX = 3.9;
export const PERMISSIONS_COLUMN_MIN_WIDTH = 200;

export const DATE_COLUMN_WIDTH = 95;

// ── Analytics ──

export const eventTag = "Roles";
export const ANALYTICS_PREFIX = "team|roles";

// ── Activity log ──

export const CUSTOM_ROLE_CREATE = "api.activity.custom.role.create";
export const CUSTOM_ROLE_DELETE = "api.activity.custom.role.delete";

// ── Roles ──

// Built-in role `name` gated behind ffKeys.ROLES_READ_ONLY; hidden from role
// pickers/lists until the flag is on. Shared with Members-v1 (change-role
// drawer + filters), which don't otherwise depend on the Roles page.
export const READ_ONLY_ROLE_NAME = "Read-Only";
